import { GameServerState } from '../Reducers'
import { Action } from 'redux'
import { GameServerAction } from './GameServerActions'

export enum GameServerStatus {
    CONNECTING = 'CONNECTING',
    CONNECTED = 'CONNECTED',
    DISCONNECTED = 'DISCONNECTED',
}

const INITIAL_STATE: GameServerState = {
	status: GameServerStatus.DISCONNECTED,
}

export function gameServerReducer(state: GameServerState = INITIAL_STATE, action: Action): GameServerState {
	switch (action.type as GameServerAction) {
        case GameServerAction.CONNECTING:
            return { ...state, status: GameServerStatus.CONNECTING }
		case GameServerAction.CONNECTED:
			return { ...state, status: GameServerStatus.CONNECTED }
		case GameServerAction.DISCONNECTED:
			return { ...state, status: GameServerStatus.DISCONNECTED }
		default:
			return state
	}
}
